/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSocialTwitter64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSocialTwitter64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M33.4979 30.3107L41.3156 21H39.463L32.6749 29.0844L27.2532 21H21L29.1986 33.225L21 42.9887H22.8527L30.0211 34.4513L35.7468 42.9887H42L33.4974 30.3107H33.4979ZM30.9604 33.3327L30.1297 32.1154L23.5202 22.4289H26.3658L31.6997 30.2462L32.5304 31.4635L39.4639 41.6248H36.6183L30.9604 33.3332V33.3327Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSocialTwitter64Icon.tags = ['x', 'twitter'];

AddPanelSocialTwitter64Icon.category = '64x64 (Add panel)';

AddPanelSocialTwitter64Icon.iconSize = 64;
